import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Account, SUPPORT_MOBILE_NUMBER, User } from 'service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faCopy, faCreditCard, faMoneyBill, faPhone, faReceipt, faShoppingCart, faUsers } from '@fortawesome/free-solid-svg-icons';
import ArthaGateway from 'service/ArthaGateway';
import { app_version, clearCache } from 'service/Utils';
import toast from 'react-hot-toast';
import { link } from 'fs';
import { ActionCreators } from 'store/actionCreators';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<User>();
    const [accounts, setAccounts] = useState<Account[]>([]);
    const [showNewAccount, setShowNewAccount] = useState(false);
    const [accountName, setAccountName] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleSearchAccount = (e) => {
        setIsLoading(true);
        const value = e.target.value;
        setAccountName(value);

        // Clear previous timer
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

        // Start a new one
        debounceTimeout.current = setTimeout(() => {
            searchAccount(accountName);
        }, 500); // 500 ms delay
    };

    const cards = [
        {
            title: 'Invoices',
            icon: faShoppingCart,
            link: '/invoices'
        },
        {
            title: 'Receipts',
            icon: faReceipt,
            link: '/receipts'
        },
        {
            title: 'Accounts',
            icon: faUsers,
            link: '/accounts'
        },
        // ... more cards
    ];

    useEffect(() => {
        if (userData.profile) {
            setUser(userData.profile.profile);
        }
    }, [userData]);

    const searchAccount = (name: string) => {
        setAccounts([]);
        setAccountName(name);
        let pageSize = 100;
        if (name.length < 3) {
            pageSize = 10;
        }
        setIsLoading(true);
        ArthaGateway.getAccounts(name, 0, 1, pageSize).then((response) => {
            setAccounts(response.entries);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            toast.error("Error fetching party details");
            console.log(error);
        });
    }

    const selectAccount = (account: Account) => {
        console.log(account);
    }

    const handleCreateNewAccount = () => {
        setShowNewAccount(true);
    };

    const handleCloseNewAccount = () => {
        setShowNewAccount(false);
    };

    const handleNewAccountAdded = (newAccountName) => {
        setShowNewAccount(false);
        searchAccount(newAccountName);
        toast.success("Account added successfully");
    };

    const goToDetails = (accountId) => {
        navigate("/account/" + accountId);
    }

    const createNewInvoice = (account) => {
        dispatch(ActionCreators.selectAccount(account));
        navigate("/invoice/new");
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <>
            <div className="page-dashboard">
                <div className="container">
                    {!showNewAccount &&
                        <>
                            <div className="row my-2">
                                <div className="col-md-12" style={{ textAlign: "center", padding: 0 }}>
                                    <input type="text" className="form-control" placeholder='Search account...' onChange={(e) => handleSearchAccount(e)} autoFocus />
                                    {isLoading && (
                                        <div
                                            className="progress position-absolute top-0 start-0 w-100"
                                            style={{ height: "6px", zIndex: 9999 }}
                                        >
                                            <div
                                                className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                                style={{ width: "100%" }}
                                            ></div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <hr />
                            <div className="row mb-2">
                                {accounts.length > 0 &&
                                    <ul className="">
                                        {accounts.map((account, index) => (
                                            <li
                                                key={index}
                                                className="card mb-2 py-2 px-3"
                                            >
                                                <div className="fw-semibold">{account.name}</div>

                                                {account.mobileNumber && <small className="text-muted">{account.mobileNumber}</small>}

                                                <div className={`fw-semibold text-end ${account.balance == 0 ? "text-secondary" : (account.balance < 0 ? "text-success" : "text-danger")}`}>
                                                    {account.balance == 0 && "₹ 0"}
                                                    {account.balance < 0 && "₹ " + Math.abs(account.balance).toLocaleString() + " Cr"}
                                                    {account.balance > 0 && "₹ " + account.balance.toLocaleString()}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className='row mb-2'>
                                <div className='col-md-12'>
                                    <div className="btn btn-sm btn-dark float-start" onClick={clearCache}>Update to latest version</div>
                                    <div className='float-end' >{app_version}</div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};